import Hero from "@/components/landing/Hero";
import PainSection from "@/components/landing/PainSection";
import AuthorityStrip from "@/components/landing/AuthorityStrip";
import MethodSection from "@/components/landing/MethodSection";
import AuthoritySection from "@/components/landing/AuthoritySection";
import ForWhomSection from "@/components/landing/ForWhomSection";
import DeliverablesSection from "@/components/landing/DeliverablesSection";
import SupportSection from "@/components/landing/SupportSection";
import CommunitySection from "@/components/landing/CommunitySection";
import TestimonialsBig from "@/components/landing/TestimonialsBig";
import ValueStackSection from "@/components/landing/ValueStackSection";
import GuaranteeSection from "@/components/landing/GuaranteeSection";
import FAQSection from "@/components/landing/FAQSection";
import FinalOffer from "@/components/landing/FinalOffer";
import LeadCaptureSection from "@/components/landing/LeadCaptureSection";
import Footer from "@/components/landing/Footer";
import FloatingWhatsapp from "@/components/landing/FloatingWhatsapp";
import InlineCTA from "@/components/landing/IntermediateCTA";
import { useEffect } from "react";
import { track, initScrollDepthTracking, initTimeOnPageTracking } from "@/lib/tracking";

export default function LandingPage() {
  useEffect(() => {
    const removeBadge = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: false });

    // Page-view tracking
    track("page_view", { path: "/", title: document.title });

    // Scroll depth + time on page
    const stopScroll = initScrollDepthTracking();
    const stopTime = initTimeOnPageTracking();

    // Delegated checkout CTA click tracking
    const onClick = (e) => {
      const link = e.target.closest("a[href*='kiwify']");
      if (!link) return;
      const testId =
        link.getAttribute("data-testid") ||
        link.closest("[data-testid]")?.getAttribute("data-testid") ||
        "unknown";
      track("checkout_cta_click", {
        cta_id: testId,
        href: link.getAttribute("href"),
        label: link.innerText?.trim().slice(0, 60),
      });
    };
    document.addEventListener("click", onClick, true);

    return () => {
      observer.disconnect();
      document.removeEventListener("click", onClick, true);
      stopScroll();
      stopTime();
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-[#f3ecf7] text-[#1f1430]">
      <main>
        {/* 1. Identificação */}
        <Hero />
        {/* 2. Dor */}
        <PainSection />
        {/* CTA 02 — após Pain (em fundo claro p/ contrastar com dark Pain) */}
        <InlineCTA
          variant="light"
          label="Quero mudar essa realidade"
          sublabel="Se você se reconheceu até aqui, existe um caminho estruturado para sair desse ciclo."
          testId="cta-after-pain"
        />
        {/* 3. Autoridade rápida */}
        <AuthorityStrip />
        {/* 4. Método */}
        <MethodSection />
        {/* CTA 03 — após Method */}
        <InlineCTA
          variant="light"
          label="Quero conhecer a Jornada"
          sublabel="Esse é o caminho que +600 famílias já percorreram."
          testId="cta-after-method"
        />
        {/* 5. Confiança (Mariana) */}
        <AuthoritySection />
        {/* 6. Para quem é */}
        <ForWhomSection />
        {/* 7. Conteúdo (entrega + suporte + bônus) */}
        <DeliverablesSection />
        {/* CTA 04 — após Deliverables */}
        <InlineCTA
          variant="light"
          label="Quero acessar todo esse conteúdo"
          sublabel="6 módulos, 21 aulas em vídeo, em ordem de aplicação."
          testId="cta-after-deliverables"
        />
        <SupportSection />
        {/* 7b. Comunidade Mariana Mello (parte integrante da oferta) */}
        <CommunitySection />
        {/* CTA 05 — após Community */}
        <InlineCTA
          variant="light"
          label="Quero fazer parte da Comunidade"
          sublabel="Lives semanais, gravações e ecossistema completo por 12 meses."
          testId="cta-after-community"
        />
        {/* 8. Prova social (movido p/ ANTES da oferta) */}
        <TestimonialsBig />
        {/* CTA 07 — após Depoimentos */}
        <InlineCTA
          variant="dark"
          label="Quero ter esse resultado"
          sublabel="A Jornada que essas mães seguiram está aberta para você agora."
          testId="cta-after-testimonials"
        />
        {/* 9. Oferta principal */}
        <ValueStackSection />
        {/* 10. Garantia */}
        <GuaranteeSection />
        {/* 11. Quebra de objeções */}
        <FAQSection />
        {/* 12. Oferta Final (fechamento emocional) */}
        <FinalOffer />
        {/* 13. Captura de leads — equipe via WhatsApp para indecisos */}
        <LeadCaptureSection />
      </main>
      <Footer />
      <FloatingWhatsapp />
    </div>
  );
}
